
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venda-direta/taxista",
      function () {
        return require("private-next-pages/venda-direta/taxista.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venda-direta/taxista"])
      });
    }
  